import { styled } from "styled-components";

export const FieldGroup = styled.div(({ theme }) => ({
  marginBottom: theme.space["4"],
}));

export const Label = styled.label(({ theme }) => ({
  display: "block",
  fontWeight: theme.fontWeights["2"],
  color: theme.colors.grayDarkest,
  marginBottom: theme.space["1"],
}));

export const HelperText = styled.div(({ theme }) => ({
  fontSize: theme.fontSizes[1],
  lineHeight: theme.lineHeights[1],
  color: theme.colors.grayDark,
}));
